<template>
    <div class="page-content animate__animated animate__fadeIn">
        <div class="border-bottom" style="margin-top:0;">
            <!-- 顶部搜索框 -->
            <div>
                <el-form :inline="true" :model="queryParams" class="demo-form-inline">
                    <el-form-item label="线路名称">
                        <el-input v-model="queryParams.circuitName" placeholder="请输入线路名称进行查询" class="form-item-width"
                            clearable></el-input>
                    </el-form-item>

                    <div class="btn-boxs">
                        <div>
                            <!-- <el-button icon="el-icon-plus" type="primary" @click="handlecircuitAdd">新 增</el-button>
                            <el-button :disabled="!multipleSelection.length" icon="el-icon-delete" type="danger"
                                @click="batchDelete">批量删除</el-button> -->
                        </div>
                        <div>
                            <el-button icon="el-icon-search" type="primary" @click="onSearch">查 询</el-button>
                            <el-button icon="el-icon-refresh" @click="onReset">重 置</el-button>
                        </div>
                    </div>
                </el-form>
            </div>
        </div>
        <div class="margin-top" style="margin-bottom:0;margin-top:15px">
            <!-- 表格组件 -->
            <el-table :data="tableData" v-loading="tableLoading" border row-key="deptId" default-expand-all
                :tree-props="{ children: 'children' }" highlight-current-row max-height="447"
                :header-cell-style="{ background: '#fafafa', color: '#606266', fontSize: '14px' }"
                @selection-change="handleSelectionChange">
                <!-- 多选 -->
                <el-table-column type="selection" width="55"></el-table-column>
                <!-- 序号列 -->
                <el-table-column align="center" type="index" label="序号" width="50"></el-table-column>
                <!-- 动态生成其他列 -->
                <el-table-column align="center" v-for="tab in tableTitle" :key="tab.code" :label="tab.name"
                    show-overflow-tooltip :width="tab.width">
                    <template slot-scope="scope">
                        <!-- 针对 status 列的特殊处理 -->
                        <span v-if="tab.code === 'lineType'">{{
                    scope.row.lineType === '0' ? '单线' : scope.row.lineType === '1' ? '上行' : '下行' }}</span>
                        <span v-else-if="tab.code === 'type'">{{ circuitMaping[scope.row.type] }}</span>
                        <span v-else>{{ scope.row[tab.code] }}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" @click="dataSynchronization(scope.row)">数据同步</el-button>
                        <el-button type="text" @click="historyData(scope.row)">历史数据</el-button>
                        <!--  <el-button style="color:red" type="text" @click="deleteData(scope.row)">删除</el-button> -->
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页组件 -->
            <div>
                <Pagination background :total="pageParams.total" :page="pageParams.pageNum" :limit="pageParams.pageSize"
                    @pagination="onChangePages" />
            </div>
        </div>
        <!-- 添加 修改角色 -->
        <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisble" width="40%" @close="handleDialogClose">
            <el-form :model="form" :rules="rules" ref="form" label-width="90px">
                <el-form-item label="线路" prop="circuitId">
                    <el-select clearable v-model="form.circuitId" placeholder="请选择线路" @change="circuitChange">
                        <el-option v-for="item in circuitList" :key="item.circuitId" :label="item.circuitName"
                            :value="item.circuitId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="行别" prop="lineType">
                    <el-select clearable v-model="form.lineType" placeholder="请选择行别" @change="lineTypeChange">
                        <el-option v-for="item in lineTypeList" :key="item.dictValue" :label="item.dictLabel"
                            :value="item.dictValue"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="线路类型" prop="classify">
                    <el-select disabled clearable v-model="form.classify" placeholder="请选择线路类型">
                        <el-option label="高铁" value="1"></el-option>
                        <el-option label="普铁" value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="开始区站" prop="startStationSign" v-if="form.lineType">
                    <el-select clearable v-model="form.startStationId" placeholder="请选择开始区站">
                        <el-option v-for="item in stationList" :key="item.stationId" :label="item.stationName"
                            :value="item.stationId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否包含开始区站" prop="startStationSign" v-if="form.lineType">
                    <el-select clearable v-model="form.startStationSign" placeholder="请选择是否包含开始区站">
                        <el-option label="是" value="1"></el-option>
                        <el-option label="否" value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="结束区站" prop="endStationId" v-if="form.lineType">
                    <el-select clearable v-model="form.endStationId" placeholder="请选择结束区站">
                        <el-option v-for="item in stationList" :key="item.stationId" :label="item.stationName"
                            :value="item.stationId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否包含结束区站" prop="endStationSign" v-if="form.lineType">
                    <el-select clearable v-model="form.endStationSign" placeholder="请选择是否包含结束区站">
                        <el-option label="是" value="1"></el-option>
                        <el-option label="否" value="0"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="起点里程" prop="startKilometer">
                    <el-input clearable v-model="form.startKilometer" placeholder="请输入起点里程"></el-input>
                </el-form-item>

                <el-form-item label="终点里程" prop="endKilometer">
                    <el-input clearable v-model="form.endKilometer" placeholder="请输入终点里程"></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input clearable v-model="form.remark" placeholder="请输入备注"></el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button :icon="dialogTitle === '新增' ? 'el-icon-plus' : 'el-icon-edit'" type="primary"
                    @click="submitForm('form')">{{ dialogTitle === '新增' ? '立即添加' : '立即修改' }}</el-button>
                <el-button icon="el-icon-refresh" @click="resetForm('form')">重 置</el-button>
            </div>
        </el-dialog>
        <!-- 数据同步 -->
        <el-dialog title="数据同步" :visible.sync="synchronizationVisible" width="30%" @close="handleDialogClose1">
            <el-form :model="synchronization" :rules="synchronizationRules" ref="synchronization" label-width="90px">
                <el-form-item label="系统类型" prop="model">
                    <el-select v-model="synchronization.model" placeholder="请选择要同步数据的系统类型"
                        @change="synchronizationChange">
                        <el-option label="1C" value="1"></el-option>
                        <el-option label="2C" value="2"></el-option>
                        <el-option label="3C" value="3"></el-option>
                        <el-option label="4C" value="4"></el-option>
                        <el-option label="5C" value="5"></el-option>
                        <el-option label="浮冰检测" value="6"></el-option>
                        <el-option label="隧道2C" value="7"></el-option>
                        <el-option label="简易4C" value="8"></el-option>
                        <el-option label="简易1C" value="9"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="数据类型" prop="type">
                    <el-select v-model="synchronization.type" placeholder="请选择要同步数据的类型">
                        <el-option v-for="item in synchronizationOptions" :key="item.id" :label="item.title"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="synchronization.model === '1' || synchronization.model === '2' || synchronization.model === '7'
                    || synchronization.model === '8' || synchronization.model === '9'" label="月份" prop="month">
                    <el-date-picker v-model="synchronization.month" type="month" placeholder="选择数据月份"
                        value-format="yyyy-MM">
                    </el-date-picker>
                </el-form-item>
                <el-form-item v-if="synchronization.model === '4'" label="年份" prop="yaer">
                    <el-date-picker v-model="synchronization.yaer" value-format="yyyy" type="year" placeholder="选择年">
                    </el-date-picker>
                </el-form-item>
                <el-form-item v-if="synchronization.model === '4'" label="季度" prop="quarter">
                    <el-select v-model="synchronization.quarter" placeholder="请选择要同步数据的季度">
                        <el-option label="一季度" value="一季度"></el-option>
                        <el-option label="二季度" value="二季度"></el-option>
                        <el-option label="三季度" value="三季度"></el-option>
                        <el-option label="四季度" value="四季度"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button :icon="dialogTitle === '新增' ? 'el-icon-plus' : 'el-icon-edit'" type="primary"
                    @click="submitForm2('synchronization')">立即同步</el-button>
                <el-button icon="el-icon-refresh" @click="resetForm2('synchronization')">重 置</el-button>
            </div>
        </el-dialog>
        <!-- 历史数据 -->
        <el-dialog title="历史数据" :visible.sync="historyVisible" width="30%" @close="handleDialogHistory">
            <el-form :model="historyForm" :rules="historyRules" ref="historyForm" label-width="90px">
                <el-form-item label="系统类型" prop="model">
                    <el-select v-model="historyForm.model" placeholder="请选择要查看数据的系统类型" @change="historyChange">
                        <el-option label="1C" value="1"></el-option>
                        <el-option label="2C" value="2"></el-option>
                        <el-option label="4C" value="4"></el-option>
                        <el-option label="隧道2C" value="7"></el-option>
                        <el-option label="简易4C" value="8"></el-option>
                        <el-option label="简易1C" value="9"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="数据类型" prop="type">
                    <el-select v-model="historyForm.type" placeholder="请选择要查看数据的类型">
                        <el-option v-for="item in dataTypeOptions" :key="item.id" :label="item.title"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="时间范围" prop="logTime">
                    <el-date-picker v-model="historyForm.logTime" type="monthrange" range-separator="至"
                        start-placeholder="开始日期" value-format="yyyy-MM" format="yyyy-MM" end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button :icon="dialogTitle === '新增' ? 'el-icon-plus' : 'el-icon-edit'" type="primary"
                    @click="submitHistory('historyForm')">确定</el-button>
                <el-button icon="el-icon-refresh" @click="resetHistory('historyForm')">重 置</el-button>
            </div>
        </el-dialog>
        <el-drawer title="历史数据" :visible.sync="drawer" direction="rtl" :before-close="handleClose" append-to-body>
            <el-table :data="historyTableData" height="920" border class="historyTable"
                header-cell-style="{ align:center }">
                <el-table-column prop="circuitName" align="center" label="线路">
                </el-table-column>
                <el-table-column prop="dataTime" align="center" label="数据日期">
                </el-table-column>
                <el-table-column prop="dataSign" align="center" label="是否同步">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.dataSign === 0 ? 'success' : 'danger'" effect="dark">
                            {{ scope.row.dataSign === 0 ? '已同步' : '未同步' }}
                        </el-tag>
                    </template>
                </el-table-column>
            </el-table>
        </el-drawer>
    </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import { getCircuitAll } from "@/api/data-service/line.js";
import { getStationAll } from "@/api/data-service/station.js";
import { getCircuitType, } from "@/api/admin-service/dictDataType.js";
import { circuitAdministerAdd, getCircuitAdministerList, updetecirCuitAdminister, deletecirCuitAdminister, circuitAdministerById, commonCogradient, getHistoryDataTime } from '@/api/data-service/pipeboundary.js'
export default {
    components: {
        Pagination
    },
    data() {
        return {
            historyTableData: [],
            drawer: false,
            synchronizationOptions: [],
            dataTypeOptions: [],
            synchronizationVisible: false,
            historyVisible: false,
            historyForm: {
                model: "",
                type: "",
                circuitId: "",
                logTime: [],
                startTime: "",
                endTime: ""
            },
            synchronization: {
                type: "",
                model: "",
                month: null,
                yaer: null,
                quarter: null,

            },
            synchronizationRules: {
                type: [{ required: true, message: "请选择数据类型", trigger: "blur" }],
                model: [{ required: true, message: "请选择系统类型", trigger: "blur" }],
                month: [{ required: true, message: "请选择数据月份", trigger: "blur" }],
                yaer: [{ required: true, message: "请选择数据年份", trigger: "blur" }],
                quarter: [{ required: true, message: "请选择数据季度", trigger: "blur" }],
            },
            historyRules: {
                type: [{ required: true, message: "请选择数据类型", trigger: "blur" }],
                model: [{ required: true, message: "请选择系统类型", trigger: "blur" }],
                logTime: [{ required: true, message: "请选择时间范围", trigger: "blur" }],
            },
            tableLoading: false,
            form: {
                circuitId: "",
                startStationId: "",
                endStationId: "",
                startStationSign: "",
                endStationSign: "",
                startKilometer: '',
                endKilometer: "",
                lineType: "",
                classify: "",
                remark: "",
            },
            rules: {
                circuitId: [{ required: true, message: "请选择线路", trigger: "blur" }],
                lineType: [{ required: true, message: "请选择行别", trigger: "blur" }],
                classify: [{ required: true, message: "请选择线路类型", trigger: "blur" }],
                startStationId: [{ required: true, message: "请选择开始区站", trigger: "blur" }],
                endStationId: [{ required: true, message: "请选择结束区站", trigger: "blur" }],
                startStationSign: [{ required: true, message: "请选择是否包含起点区站", trigger: "blur" }],
                endStationSign: [{ required: true, message: "请选择是否包含结束区站", trigger: "blur" }],
                startKilometer: [{ required: true, message: "请填写起点里程", trigger: "blur" }],
                endKilometer: [{ required: true, message: "请填写终点里程", trigger: "blur" }],
            },
            dialogTitle: "",
            updateId: "", //修改数据需要的id
            dialogFormVisble: false,
            // 表格数据
            tableData: [],
            // 表格标题数组
            tableTitle: [
                { name: "线路", code: "circuitName", width: "" },
                { name: "行别", code: "lineType", width: "" },
                // { name: "线路类型", code: "classify", width: "" },
                { name: "起点名称", code: "startStationName", width: "" },
                { name: "终点名称", code: "endStationName", width: "" },
                { name: "起点里程", code: "startKilometer", width: "" },
                { name: "终点里程", code: "endKilometer", width: "" },
                { name: "备注", code: "remark", width: "" },
            ],
            pageParams: {
                pageNum: 1,
                pageSize: 10,
                total: 0
            },
            queryParams: {
                circuitName: "" //管界名称
            },
            multipleSelection: [],
            circuitTypeList: [],
            circuitList: [],
            lineTypeList: [],
            stationList: [],
            circuitMaping: {},
            dataSynchronizationRow: {}
        };
    },
    mounted() {
        this.onGetDataList();
        this.queryCircuitTypeList();
        this.init()
    },
    methods: {
        synchronizationChange(val) {
            this.synchronization.type = ''
            if (val === '1') {
                this.synchronizationOptions = [
                    {
                        id: '001',
                        title: '数据',
                        value: '1'
                    },
                    {
                        id: '002',
                        title: '视频',
                        value: '2'
                    },
                    {
                        id: '003',
                        title: '波形图',
                        value: '3'
                    },
                ]
            } else if (val === '2' || val === '7') {
                this.synchronizationOptions = [
                    {
                        id: '002',
                        title: '视频',
                        value: '2'
                    },
                ]
            } else if (val === '3' || val === '8' || val === '9') {
                this.synchronizationOptions = [
                    {
                        id: '001',
                        title: '数据',
                        value: '1'
                    },
                ]
            } else if (val === '4') {
                this.synchronizationOptions = [
                    {
                        id: '004',
                        title: '图片',
                        value: '4'
                    },
                ]
            } else {
                this.synchronizationOptions = []
            }
        },
        historyChange() {
            this.dataTypeOptions = [
                {
                    id: '001',
                    title: '数据',
                    value: '1'
                },
                {
                    id: '002',
                    title: '视频',
                    value: '2'
                },
                {
                    id: '003',
                    title: '波形图',
                    value: '3'
                },
            ]
            this.historyForm.type = '1'
        },
        handleDialogClose1() {
            this.resetForm("synchronization");
        },
        handleDialogHistory() {
            this.resetHistory("historyForm");
        },
        resetHistory(formName) {
            this.$refs[formName].resetFields();
        },
        submitHistory(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    const [startTime, endTime] = this.historyForm.logTime || [];
                    getHistoryDataTime({ ...this.historyForm, startTime, endTime }).then(res => {
                        if (res.code === '200') {
                            this.historyTableData = res?.data
                        }
                    })
                    this.drawer = true
                }
            });
        },
        handleClose() {
            this.drawer = false
        },
        // 增 / 改
        submitForm2(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    // 数据同步
                    this.showLoading('数据同步中...')
                    if (this.synchronization.month) {
                        var date = this.synchronization.month.split('-');
                        this.synchronization.yaer = date[0] + "年";
                        this.synchronization.month = parseInt(date[1]) + "月";
                    }
                    if (this.synchronization.yaer && this.synchronization.model == '4') {
                        this.synchronization.yaer = this.synchronization.yaer + "年";

                    }
                    commonCogradient({
                        ...this.synchronization,
                        circuitId: this.dataSynchronizationRow.circuitId
                    }).then(res => {
                        if (res.code === '200') {
                            this.$message.success('数据同步成功！' || res?.msg)
                            this.synchronization = this.$options.data().synchronization
                            this.synchronizationVisible = false
                        }

                    }).finally(() => {
                        this.hideLoading()
                    })

                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        resetForm2(formName) {
            this.$refs[formName].resetFields();
        },
        dataSynchronization(row) {
            this.dataSynchronizationRow = row

            this.synchronizationVisible = true

        },
        init() {
            getCircuitAll({
                ...this.queryParams,
                ...this.pageParams
            }).then(res => {
                if (res.code === '200') {
                    this.circuitList = res?.data
                }

            })
        },
        queryStaionList(circuitId, lineType) {
            getStationAll({
                stationName: "", //区站名称
                circuitId,
                lineType,
                ...this.pageParams
            }).then(res => {
                this.stationList = res?.data || [];
            });
        },
        lineTypeChange(val) {
            this.form.startStationId = "";
            this.form.endStationId = "";
            this.form.startStationSign = "";
            this.form.endStationSign = "";
            this.queryStaionList(this.form.circuitId, val);
        },
        circuitChange(newValue) {

            this.form.lineType = "";
            this.form.startStationId = "";
            this.form.endStationId = "";
            this.form.startStationSign = "";
            this.form.endStationSign = "";
            this.form.classify = "";
            // this.queryParams.circuitId = newValue;
            this.circuitList.forEach(item => {
                if (item.circuitId === newValue) {
                    if (item.classify === '1') {
                        this.form.classify = '1'
                    } else {
                        this.form.classify = '0'

                    }

                    if (item.type === "0") {
                        // 说明是单线
                        this.lineTypeList = [
                            {
                                dictLabel: "单线",
                                dictValue: "0"
                            }
                        ];
                    } else {
                        this.lineTypeList = [
                            {
                                dictLabel: "上行",
                                dictValue: "1"
                            },
                            {
                                dictLabel: "下行",
                                dictValue: "2"
                            }
                        ];
                    }
                }

            });
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        queryCircuitTypeList() {
            getCircuitType({ type: "sys_circuit_type" }).then(res => {
                this.circuitTypeList = res?.data || [];
                // 创建一个映射对象
                const circuitMaping = this.circuitTypeList.reduce((map, item) => {
                    map[item.dictValue] = item.dictLabel; // 将 dictLabel 作为键，dictValue 作为值
                    return map;
                }, {});
                this.circuitMaping = circuitMaping;
            });
        },
        batchDelete() {
            this.$confirm(`提示，确定要删除选中的这些数据吗？`, {
                title: "提示",
                showCancelButton: true,
                confirmButtonText: "确 定",
                cancelButtonText: "取 消",
                type: "warning",
                // 为按钮添加图标并设置为 mini 尺寸
                confirmButtonClass: "el-icon-check el-button--mini", // 确定按钮的图标和尺寸
                cancelButtonClass: "el-icon-close el-button--mini" // 取消按钮的图标和尺寸
            })
                .then(() => {
                    // 使用 map() 来获取 circuitId 组成的数组
                    const ids = (this.multipleSelection || []).map(
                        item => item.circuitId
                    );
                    deletecirCuitAdminister({ ids }).then(res => {
                        if (res?.data) {
                            this.$message.success(res.msg || "删除成功");
                            this.onGetDataList();
                        }
                    });
                })
                .catch(error => {
                    console.log(error);
                    // 取消删除时显示提示
                    this.$message({
                        type: "info",
                        message: "已取消删除"
                    });
                });
        },
        addData() {
            this.dialogTitle = "新增";
            this.dialogFormVisble = true;
        },
        // 增 / 改
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    const formData = { ...this.form };
                    delete formData.circuitAdministerId; // 清除 circuitAdministerId
                    if (this.dialogTitle === "新增") {
                        circuitAdministerAdd(formData).then(res => {
                            if (res.data) {
                                this.$message.success(res.msg || "新增成功！");
                                this.dialogFormVisble = false;
                                this.onGetDataList();
                            }
                        });
                    } else {
                        updetecirCuitAdminister({
                            ...this.form,
                            circuitAdministerId: this.updateId
                        }).then(r => {
                            if (r.data) {
                                this.$message.success(r.msg || "修改成功！");
                                this.dialogFormVisble = false;
                                this.onGetDataList();
                            }
                        });
                    }
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        // 删
        deleteData(row) {
            this.$confirm(`提示，确定要删除该条数据吗？`, {
                title: "提示",
                showCancelButton: true,
                confirmButtonText: "确 定",
                cancelButtonText: "取 消",
                type: "warning",
                // 为按钮添加图标并设置为 mini 尺寸
                confirmButtonClass: "el-icon-check el-button--mini", // 确定按钮的图标和尺寸
                cancelButtonClass: "el-icon-close el-button--mini" // 取消按钮的图标和尺寸
            })
                .then(() => {
                    deletecirCuitAdminister({ ids: [row.circuitAdministerId] }).then(res => {
                        if (res?.data) {
                            this.$message.success(res.msg || "删除成功");
                            this.onGetDataList();
                        }
                    });
                })
                .catch(error => {
                    console.log(error);
                    // 取消删除时显示提示
                    this.$message({
                        type: "info",
                        message: "已取消删除"
                    });
                });
        },
        // 改
        updateData(row) {
            this.dialogTitle = "修改";
            this.dialogFormVisble = true;
            this.updateId = row.circuitAdministerId;
            circuitAdministerById({ id: row.circuitAdministerId }).then(res => {
                const { lineType, circuitId } = res.data
                this.queryStaionList(circuitId, lineType)
                this.circuitList.forEach(item => {
                    if (item.circuitId === circuitId) {
                        if (item.classify === '1') {
                            this.form.classify = '1'
                        } else {
                            this.form.classify = '0'

                        }
                        if (item.type === "0") {
                            // 说明是单线
                            this.lineTypeList = [
                                {
                                    dictLabel: "单线",
                                    dictValue: "0"
                                }
                            ];
                        } else {
                            this.lineTypeList = [
                                {
                                    dictLabel: "上行",
                                    dictValue: "1"
                                },
                                {
                                    dictLabel: "下行",
                                    dictValue: "2"
                                }
                            ];
                        }
                        this.form.lineType = lineType
                    }
                })
                Object.assign(this.form, res?.data);
            });
        },
        // 查
        onGetDataList() {
            this.tableLoading = true;
            getCircuitAdministerList({
                ...this.queryParams,
                ...this.pageParams
            })
                .then(res => {
                    const { records, total } = res.data;
                    this.tableData = records.map(item => {
                        return {
                            ...item,
                            startStationName: item.startStationSign === '1' ? item.startStationName : item.startStationName + '(不含)',
                            endStationName: item.endStationSign === '1' ? item.endStationName : item.endStationName + '(不含)',
                        }
                    });
                    this.pageParams.total = total;
                })
                .finally(() => {
                    this.tableLoading = false;
                });
        },

        handlecircuitAdd() {
            this.dialogTitle = "新增";
            this.dialogFormVisble = true;
        },
        handleDialogClose() {
            this.resetForm("form");
        },

        // 查询
        onSearch() {
            this.onGetDataList();
        },
        // 重置
        onReset() {
            this.pageParams.pageNum = 1;
            this.pageParams.pageSize = 10;
            this.queryParams.circuitName = "";
            this.onSearch();
        },
        // 分页方法
        onChangePages(pageInfo) {
            this.pageParams.pageNum = pageInfo.page;
            this.pageParams.pageSize = pageInfo.limit;
            this.onGetDataList();
        },
        historyData(row) {
            this.historyForm.circuitId = row.circuitId
            this.historyVisible = true
        }
    }
};
</script>
<style lang="less" scoped>
.analyse-container {
    display: flex;
    height: 95vh;
}

.form-item-width {
    width: 250px;
}

.right-btns {
    position: absolute;
    right: 20px !important;
}

.border-bottom {
    border-bottom: 1px solid #e2e2e4;
}

.margin-top {
    margin-top: -15px;
}

.custom-tree-node {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;

    .tree-node-label {
        font-size: 12px;
        font-weight: bold;
    }
}

.historyTable {
    margin-left: 10px;
    width: 89.9%;
}
</style>